export type ChangelogEntryType = "feature" | "bugfix" | "improvement" | "announcement"
export type ChangelogPriority = "low" | "normal" | "high" | "critical"

export interface ChangelogEntry {
  _id: string
  type: ChangelogEntryType
  title: string
  description: string
  version: string
  priority: ChangelogPriority
  tags: string[]
  system_ticket: string | null
  created_by_name: string
  published_at: number
  created_at: number
}

export const ENTRY_TYPE_CONFIG: Record<
  ChangelogEntryType,
  { label: string; color: string; bgColor: string; borderColor: string }
> = {
  feature: {
    label: "New Feature",
    color: "text-primary",
    bgColor: "bg-primary/10",
    borderColor: "border-primary",
  },
  bugfix: {
    label: "Bug Fix",
    color: "text-green-600 dark:text-green-400",
    bgColor: "bg-green-500/10",
    borderColor: "border-green-500",
  },
  improvement: {
    label: "Improvement",
    color: "text-purple-600 dark:text-purple-400",
    bgColor: "bg-purple-500/10",
    borderColor: "border-purple-500",
  },
  announcement: {
    label: "Announcement",
    color: "text-amber-600 dark:text-amber-400",
    bgColor: "bg-amber-500/10",
    borderColor: "border-amber-500",
  },
}
